import { Intro } from "@/components/site/Gallery";
import { zl } from "@/lib/api";

export const Packs = ({ c, onPick }) => (
  <section id="pakiety" data-testid="packs-section">
    <Intro c={c} />
    <div className="packs">
      {c.items.map((p, i) => (
        <article key={i} className={`pack${p.featured ? " featured" : ""}`} data-testid={`pack-${i}`}>
          {p.featured && p.flag && <span className="flag">{p.flag}</span>}
          <p className="label">{p.occasion}</p>
          <h3>{p.title}</h3>
          <p>{p.desc}</p>
          <ul>{p.features.map((f, j) => <li key={j}>{f}</li>)}</ul>
          <div className="price">od <b>{zl(p.price)}</b></div>
          <a className={`btn ${p.featured ? "solid" : "line"}`} href="#kontakt" onClick={() => onPick(p.occasion)} data-testid={`pack-pick-btn-${i}`}>{c.button}</a>
        </article>
      ))}
    </div>
  </section>
);

export const Process = ({ c }) => (
  <section id="proces" data-testid="process-section">
    <Intro c={c} />
    <ol className="steps">
      {c.steps.map((s, i) => <li key={i}><span className="when">{s.when}</span><h3>{s.title}</h3><p>{s.text}</p></li>)}
    </ol>
  </section>
);

export const Addons = ({ c, selected, onToggle }) => (
  <section id="dodatki" data-testid="addons-section">
    <Intro c={c} />
    <div className="addons">
      {c.items.map((a, i) => {
        const on = selected.includes(a.name);
        return (
          <button type="button" key={i} className={`addon addon-btn${on ? " on" : ""}`} onClick={() => onToggle(a.name)} aria-pressed={on} data-testid={`addon-toggle-${i}`}>
            <span>{a.name}<small>{a.desc}</small></span>
            <span className="addon-right"><b>{zl(a.price)}</b><em className="addon-mark">{on ? "Dodano ✓" : "+ Dodaj"}</em></span>
          </button>
        );
      })}
    </div>
    <p className="fine">{c.fine} Zaznaczone dodatki trafią automatycznie do formularza rezerwacji.</p>
  </section>
);

export const Owners = ({ c }) => (
  <section id="wlasciciele" data-testid="owners-section">
    <div className="owners">
      <div><p className="label">{c.label}</p><h2>{c.title}</h2><p>{c.text}</p></div>
      <ul>{c.items.map((o, i) => <li key={i}><b>{o.title}</b><span>{o.text}</span></li>)}</ul>
    </div>
  </section>
);

export const Faq = ({ c }) => (
  <section id="faq" data-testid="faq-section">
    <div className="faq">
      <div><p className="label">{c.label}</p><h2>{c.title}</h2></div>
      <div className="faq-list">
        {c.items.map((q, i) => (
          <details key={i} open={i === 0} data-testid={`faq-item-${i}`}><summary>{q.q}</summary><p>{q.a}</p></details>
        ))}
      </div>
    </div>
  </section>
);
